import React from "react";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import { connect } from "react-redux";
import { useAvailableYears } from "./data";
import _ from "lodash";

/**
 * Filtro de selección de periodos
 */
const YearSelector = (props) => {
	const { value, handleChange, typing, indicator } = props;
	const { data } = useAvailableYears(indicator, typing);
	const orderData = _.map(data, "representation");
	const yearsMenu = orderData.map((representation, key) => {
		const splitValue = _.split(representation, "-");
		return (
			<MenuItem value={representation} key={key}>
				{splitValue[0] && splitValue[0].length < 4 && splitValue[1]
					? `${splitValue[1]}-${splitValue[0]}`
					: splitValue[1] && splitValue[0].length === 4
					? `${splitValue[1]}-${splitValue[0]}`
					: splitValue[0]}
			</MenuItem>
		);
	});
	return (
		<TextField
			id="outlined-select-year"
			select
			label="Período"
			value={value}
			onChange={(event) => {
				handleChange("year", event.target.value);
			}}
			margin="normal"
			variant="outlined"
			fullWidth
			disabled={data.length === 0}
			InputLabelProps={{
				shrink: true
			}}
		>
			{yearsMenu}
		</TextField>
	);
};

const mapStateToProps = ({ filters }) => ({
	typing: filters.get("typing"),
	indicator: filters.get("disease")
});

export const YearSelectorRedux = connect(mapStateToProps, null)(YearSelector);
export default YearSelector;



// WEBPACK FOOTER //
// ./src/components/filters/year-selector/index.js